<template>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
          <button
              type="button"
              class="btn btn-outline-secondary"
              @click="toggleDropdown"
          >
              <span class="fa fa-caret-down" />&nbsp; {{ schema }}
          </button>
          <div
              class="dropdown-menu"
              :class="{show: dropdown}"
          >
              <span
                  class="dropdown-item pointer" 
                  title="Защищенное соединение, предпочтительно"
                  @click="setSchema('https://')"
              >
                  https://
              </span>
              <span
                class="dropdown-item pointer"
                title=""
                @click="setSchema('http://')"
              >
                  http://
              </span>
          </div>
      </div>
      <input 
        ref="input"
        v-model="url"
        type="text"
        class="form-control"
        autocomplete="off"
        :class="{'is-invalid': !valid}"
        :placeholder="placeholder"
        :required="required"
        @input="validate"
      >
    </div>
</template>

<script>
    export default {
        props: {
            val: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: '',
            },
            placeholder: {
                type: String,
                default: '',
            },
            required: {
                type: Boolean,
                default: false,
            },
            autofocus: {
                type: Boolean,
                default: false,
            },
        },
        data: function() {
            return { 
                url: '',
                schema: 'https://',
                value: '',
                valid: true,
                dropdown: false,
            }
        },
        mounted: function() {
            if (this.val) {
                this.schema = this.val.includes('https') ? 'https://' : 'http://';
                this.url = this.val.split('//')[1];
            }
            this.validate();
            this.$emit('change', this.value, this.valid); 
            console.log(this);
            if (this.autofocus) {
                this.$refs.input.focus();
            }
        },
        methods: {
            toggleDropdown: function() {
                this.dropdown = !this.dropdown;
            },
            setSchema: function(schema) {
                this.schema = schema;
                this.dropdown = false; 
                this.validate();
            },
            validate: function() {
                if (this.url.includes('://')) {
                    this.url = this.url.split('://')[1]
                }

                if (!this.required && !this.url.trim()) {
                    this.valid = true;
                } else {
                    if (!this.validateURL(this.schema+this.url)) {
                        this.valid = false;
                    } else {
                        this.valid = true;
                    }
                }

                this.emitChange()
            },
            emitChange: function(val) {
                if (this.valid) {
                    if (this.url.trim()) {
                        this.value =  this.schema+this.url; 
                        this.$emit('change', this.value, this.valid);
                    } else {
                        this.value = ''; 
                    }
                    this.$emit('change', this.value, this.valid); 
                } else {
                    this.$emit('change', '', this.valid); 
                }
            },
            validateURL: function(value) {
                  return /^(?:(?:(?:https?):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
            }
        },
    }
</script>
